import CenteredSpinner from "@/components/centered-spinner";

const Loader = () => (
  <div className="h-full w-full">
    <CenteredSpinner />
  </div>
);

export default Loader;
